/***
 * @ngdoc directive
 * @name BB:bbMultiServiceSelect
 * @restrict AE
 * @scope true
 *
 * @description
 *
 * Enables selection of multiple services for the currently in scope company
 *
 * NOTE: This directive needs to be used with bbTimeRangeStacked directive
 * This directive must be placed within the _service.html template or equivalent
 * The bbTimeRangeStacked directive should be used on the same scope as bbTimeRanges to enable this feature
 *
 * The template (_service.html) should be updated to use addItem() and removeItem() to select services
 *
 * WARNING: this does not work well with booking multiple services which have pre and post times
 * pre and post times are not considered so bookings may overlap
 *
 * <pre>
 * restrict: 'AE'
 * scope: true
 * </pre>
 *
 * @param {hash}  bbMultiServiceSelect A hash of options
 * @property {object} options The options of service
 * @property {object} max_services The max services
 * @property {boolean} ordered_categories Verify if categories are ordered or not
 * @property {array} services The services
 * @property {array} company The company
 * @property {array} items An array of items service
 * @property {object} alert The alert service - see {@link BB:Alert Alert Service}
 *///


angular.module('BBPublicBooking').directive('bbMultiServiceSelect', () => {
        return {
            restrict: 'AE',
            scope: true,
            controller: 'MultiServiceSelect'
        };
    }
);



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/multiservice-select/bb_multiservice_select.directive.js